<template>
  <div>
    <Tab @close="removeCurrent">
      <template #toolbar-help>
        <v-btn class="tw-mr-2" fab text x-small :title="$t('dashboard.help.show')" @click="showHelp(menu,page)">
            <span class="mr-1">
              <v-icon color="primary" x-small>fa fa-question</v-icon>
            </span>
        </v-btn>
      </template>
      <template #toolbar-items>
        <!-- ------------------------ MENU Update product ------------------------ -->
        <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'product_list'"
          icon="fa-tags"
          name="product_list"
        ></TabToolbarButton>
        <!-- ------------------------ MENU Add one product ------------------------ -->
        <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'product_add'"
          icon="fa-edit"
          name="product_add"
        ></TabToolbarButton>
        <!-- ------------------------ MENU Import product ------------------------ -->
        <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'product_import'"
          icon="fa-file-csv"
          name="product_import"
        ></TabToolbarButton>
        <!-- ------------------------ MENU Add brands ------------------------ -->
        <TabToolbarButton
          v-model="page"
          :menu="menu"
          :selected="page === 'brand'"
          icon="fa-trademark"
          name="brand"
        ></TabToolbarButton>
      </template>
      <template #container>
        <!-- ------------------------ TAB List & Update product ------------------------ -->
        <TabPage :menu="menu" :page="page" documentation-path="manager/products/product-list" name="product_list">
          <template #content>
            <v-container v-show="!update_product_edit">
              <v-row>
                <v-col cols="12" sm="9">
                  {{ $t("products.product_list.list") }}
                  <div class="float-right" style="position:relative; top:-5px;">
                    <v-btn :title="$t('stories.manager.list.reload')" color="primary" icon @click="fetchProducts()">
                      <v-icon small>fas fa-sync-alt</v-icon>
                    </v-btn>
                  </div>
                  <v-data-table
                    :headers="productsDatatableHeaders"
                    :items="productsDatatableItems"
                    :items-per-page="15"
                    :loading="productsLoading"
                    :search="productsSearch"
                    class="mt-4"
                    item-key="id"
                  >
                    <template v-slot:item.edit="{ item }">
                      <div class="sr-flex-row">
                        <v-btn :title="$t('products.product_list.actions.edit')"
                               icon
                               small
                               @click="loadProductForUpdate(item)"
                        >
                          <v-icon small>fas fa-edit</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <template v-slot:item.commercial_name="props">
                      <span class="mr-1" v-html="highlightSearch(props.item.commercial_name, productsSearch)"></span>
                    </template>
                    <template v-slot:item.brand="props">
                      <v-dialog v-model="props.item.description_modal">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-on="on"
                            :title="$t('urls.url.description_action')"
                            class="tw-cursor-pointer hover:tw-text-red-900"
                            @click="openDescription(props.item)"
                            v-html="
                              highlightSearch(props.item.description != '' ? props.item.description : '...', urlsSearch)
                            "
                          ></div>
                        </template>
                        <v-card>
                          <v-card-title class="title">
                            {{ $t("urls.url.update_description") }}
                          </v-card-title>
                          <v-card-text>
                            <v-textarea
                              v-model="props.item.description"
                              :label="$t('urls.url.edit_description')"
                              autofocus
                              class="mt-4"
                              counter="160"
                              no-resize
                            ></v-textarea>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="cancelDescription(props.item)"
                              >{{ $t("urls.url.cancel_description") }}
                            </v-btn>
                            <v-btn text @click="saveDescription(props.item)"
                              >{{ $t("urls.url.save_description") }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                    <!-- Col ACTIONS -->
                    <template v-slot:item.actions="{ item }">
                      <div class="sr-flex-row">
                        <v-btn :title="$t('products.product_list.actions.view')"
                          icon
                          small
                          @click="viewProductStatistics(item)"
                        >
                          <v-icon small>fas fa-chart-bar</v-icon>
                        </v-btn>
                        <v-btn :title="$t('products.product_list.actions.delete')"
                          icon
                          small
                          @click="deleteProduct(item)"
                        >
                          <v-icon small>fas fa-trash</v-icon>
                        </v-btn>
                        <v-btn :title="$t('products.product.rate')"
                               icon small @click="rateNow(item)">
                          <v-icon x-small>
                            fa-star
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" sm="3">
                  <section v-if="productStatistics.product_id > 0">
                    <v-row v-if="productStatistics.publicationsCount > 0">
                      <v-col cols="12">
                        <br>
                        <br>
                        <br>
                        <b v-html="$t('products.product_statistics.title')"></b>
                      </v-col>
                      <v-col cols="6"
                        ><i>{{ $t("products.product_statistics.product") }}</i></v-col
                      >
                      <v-col cols="6"
                        ><b>{{ productStatistics.commercial_name }}</b></v-col
                      >

                      <v-col cols="6"
                        ><i>{{ $t("products.product_statistics.publicationsCount") }}</i></v-col
                      >
                      <v-col cols="6"
                        ><b>{{ productStatistics.publicationsCount }}</b></v-col
                      >

                      <v-col cols="6"
                        ><i>{{ $t("products.product_statistics.rating") }}</i></v-col
                      >
                      <v-col cols="6"
                        ><b>{{ productStatistics.rating }} / 5</b></v-col
                      >

                      <v-col cols="12"
                        ><i>{{ $t("products.product_statistics.details") }}</i></v-col
                      >

                      <v-col class="pa-0" cols="1" offset="1"
                        ><b>{{ productStatistics.details[5]["c"] }}</b></v-col
                      >
                      <v-col class="pa-0" cols="10"
                        ><i>{{ $t("products.product_statistics.note_5") }}</i></v-col
                      >
                      <v-col class="pa-0" cols="1" offset="1"
                        ><b>{{ productStatistics.details[4]["c"] }}</b></v-col
                      >
                      <v-col class="pa-0" cols="10"
                        ><i>{{ $t("products.product_statistics.note_4") }}</i></v-col
                      >
                      <v-col class="pa-0" cols="1" offset="1"
                        ><b>{{ productStatistics.details[3]["c"] }}</b></v-col
                      >
                      <v-col class="pa-0" cols="10"
                        ><i>{{ $t("products.product_statistics.note_3") }}</i></v-col
                      >
                      <v-col class="pa-0" cols="1" offset="1"
                        ><b>{{ productStatistics.details[2]["c"] }}</b></v-col
                      >
                      <v-col class="pa-0" cols="10"
                        ><i>{{ $t("products.product_statistics.note_2") }}</i></v-col
                      >
                      <v-col class="pa-0" cols="1" offset="1"
                        ><b>{{ productStatistics.details[1]["c"] }}</b></v-col
                      >
                      <v-col class="pa-0" cols="10"
                        ><i>{{ $t("products.product_statistics.note_1") }}</i></v-col
                      >
                    </v-row>
                    <v-row v-else>
                      <v-col cols="12">
                        <br>
                        <br>
                        <br>
                        <span v-html="$t('products.product_statistics.no_data')"></span>
                      </v-col>
                    </v-row>
                  </section>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-show="update_product_edit">
              <Form ref="updateProduct" :callback="updateProduct">
                <v-row>
                  <v-col lg="6" sm="12">
                    <FormField v-model="update_product.internal_code"
                               i18n="products.product.internal_code"
                               input-type="text"
                               place-holder=" "
                    />
                  </v-col>
                  <v-col lg="6" sm="12">
                    <FormField style="float:right;" v-model="customerInternalCode"
                        :props="{ readOnly: true }"
                        :read-only="true"
                        i18n="products.product.internal_code"
                        input-type="text"
                        place-holder=" "
                        rules="required"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col lg="6" sm="12">
                    <FormField v-model="update_product.ean"
                               i18n="products.product.ean"
                               input-type="text"
                               place-holder=" "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12">
                    <FormField v-model="update_product.product_familly"
                               i18n="products.product.product_familly"
                               input-type="text"
                               place-holder=" "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col lg="6" sm="12">
                    <v-checkbox v-model="update_product.is_not_visible"
                      hide-details
                      :label="$t('products.product.is_visible')"
                      :value="true"
                    ></v-checkbox>
                  </v-col>
                  <v-col lg="6" sm="12">
                    <v-checkbox v-model="update_product.is_not_sharable"
                        hide-details
                        :label="$t('products.product.is_sharable')"
                        :value="true"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col lg="6" sm="12">
                    <v-autocomplete v-model="update_product.brand_id"
                      :items="brand.items"
                      :label="$t('products.product.brand')"
                      item-text="brand_name"
                      item-value="id"
                    />
                  </v-col>
                  <v-col lg="6" sm="12">
                    <FormField v-model="update_product.commercial_name"
                               i18n="products.product.commercial_name"
                               input-type="text"
                               place-holder=" "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col lg="6" sm="12">
                    <FormField v-model="update_product.product_url"
                               i18n="products.product.product_url"
                               input-type="url"
                               not-required
                               place-holder="https://.."
                    />
                  </v-col>
                  <v-col lg="6" sm="12">
                    <FormField v-model="update_product.image_url"
                               i18n="products.product.image_url"
                               input-type="url"
                               not-required
                               place-holder="https://.."
                    />
                  </v-col>
                  <v-col lg="6" sm="12">
                    <FormField v-model="update_product.invitation_url"
                               i18n="products.product.invitation_url"
                               input-type="url"
                               not-required
                               place-holder="https://.."
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col lg="6" sm="12">
                    <v-textarea v-model="update_product.commercial_description"
                    :label="$t('products.product.commercial_description')"
                    rows="3"
                ></v-textarea>
                  </v-col>
                  <v-col lg="6" sm="12">
                    <v-textarea v-model="update_product.review_description"
                    :label="$t('products.product.review_description')"
                    rows="3"
                ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" >
                  <v-checkbox v-model="update_product.exclude_free"
                      hide-details
                      :label="$t('products.product.exclude_free')"
                      :value="true"
                  ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="12" >
                    <div class="tw-mt-4 tw-font-semibold">
                      {{ $t("websites.reviews_params.form.order_title") }}
                    </div>
                    <v-radio-group v-model="update_product.list_order">
                      <v-radio
                          :label="$t('websites.reviews_params.form.order_last_label')"
                          value="last"
                      ></v-radio>
                      <v-radio
                          :label="$t('websites.reviews_params.form.order_best_label')"
                          value="best"
                      ></v-radio>
                      <v-radio
                          :label="$t('websites.reviews_params.form.order_pertinent_label')"
                          value="pert"
                      ></v-radio>
                      <v-radio
                          :label="$t('websites.reviews_params.form.order_liked_label')"
                          value="like"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="tw-mt-1 tw-font-semibold">
                      {{ $t("websites.reviews_params.form.age_selection") }}
                    </div>
                    <div class="tw-mt-1 tw-ml-8 tw-mr-20">
                      <v-select class=""
                                hide-details
                                v-model="update_product.max_age"
                                :items="max_ages"
                                :label="$t('websites.reviews_params.form.max_age')"
                                col="6"
                                item-text="label"
                                item-value="val"
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn class="mt-4 primary" small @click="$refs.updateProduct.validate()">
                      {{ $t("products.product.update") }}
                    </v-btn>
                    <v-btn class="ml-2 mt-4 default" small @click="update_product_edit = false">
                      {{ $t("products.product.cancel") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </Form>
            </v-container>
          </template>
        </TabPage>
        <!-- ------------------------ TAB Add One product ------------------------ -->
        <TabPage :menu="menu" :page="page" documentation-path="manager/products/product-add" name="product_add">
          <template #content>
            <v-container>
              <Form ref="createProduct" :callback="createProduct">
                <FormField v-model="product.internal_code"
                  :props="{ readOnly: product.id !== null }"
                  :read-only="product.id !== null"
                  i18n="products.product.internal_code"
                  input-type="text"
                  place-holder=" "
                  rules="required"
                />
                <FormField v-model="product.commercial_name"
                  i18n="products.product.commercial_name"
                  input-type="text"
                  place-holder=" "
                />
                <v-checkbox v-model="product.is_not_visible"
                    :label="$t('products.product.is_visible')"
                    :value="true" hide-details
                ></v-checkbox>
                <v-checkbox v-model="product.is_not_sharable"
                    :label="$t('products.product.is_sharable')"
                    :value="true" hide-details
                ></v-checkbox>
                <v-autocomplete v-model="product.brand_id"
                  :items="brand.items"
                  :label="$t('products.product.brand')"
                  class="mt-4"
                  item-text="brand_name"
                  item-value="id"
                />
                <FormField v-model="product.ean"
                           i18n="products.product.ean"
                           input-type="text" place-holder=" "
                />
                <FormField v-model="product.product_url"
                    i18n="products.product.product_url"
                    input-type="url"
                    not-required
                    place-holder="https://..."
                />
                <FormField v-model="product.image_url"
                  i18n="products.product.image_url"
                  input-type="url"
                  not-required
                  place-holder="https://..."
                />
                <FormField v-model="product.invitation_url"
                    i18n="products.product.invitation_url"
                    input-type="url"
                    not-required
                    place-holder="https://..."
                />
                <v-checkbox v-model="product.exclude_free"
                    :label="$t('products.product.exclude_free')"
                    hide-details
                    :value="true"
                ></v-checkbox>

                <div class="tw-mt-4 tw-font-semibold">
                  {{ $t("websites.reviews_params.form.order_title") }}
                </div>
                  <v-radio-group v-model="product.list_order">
                  <v-radio
                      :label="$t('websites.reviews_params.form.order_last_label')"
                      value="last"
                  ></v-radio>
                  <v-radio
                      :label="$t('websites.reviews_params.form.order_best_label')"
                      value="best"
                  ></v-radio>
                  <v-radio
                      :label="$t('websites.reviews_params.form.order_pertinent_label')"
                      value="pert"
                  ></v-radio>
                  <v-radio
                      :label="$t('websites.reviews_params.form.order_liked_label')"
                      value="like"
                  ></v-radio>
                </v-radio-group>
                <v-row>
                  <v-col cols="12">
                    <div class="tw-mt-1 tw-font-semibold">
                      {{ $t("websites.reviews_params.form.age_selection") }}
                    </div>
                    <div class="tw-mt-1 tw-ml-8 tw-mr-20">
                      <v-select class=""
                                hide-details
                                v-model="product.max_age"
                                :items="max_ages"
                                :label="$t('websites.reviews_params.form.max_age')"
                                col="6"
                                item-text="label"
                                item-value="val"
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
                <v-btn class="mt-4 primary" small @click="$refs.createProduct.validate()">
                  {{ $t("products.product.create") }}
                </v-btn>
              </Form>
            </v-container>
          </template>
        </TabPage>
        <!-- ------------------------ TAB Import product ------------------------ -->
        <TabPage :menu="menu" :page="page" documentation-path="manager/products/product-import" name="product_import">
          <template #content>
            <v-container>
              <div class="tw-mb-4" v-html="$t('products.product.help')"></div>
              <DragAndDropField
                v-model="files"
                :extensions="extensions"
                :loading="uploading"
                size="40M"
              ></DragAndDropField>

              <v-btn v-if="files.length > 0" class="mt-4 primary" small @click="sendProduct">
                {{ $t("products.product.send") }}
              </v-btn>
            </v-container>
          </template>
        </TabPage>
        <!-- ------------------------ TAB brand ------------------------ -->
        <TabPage :menu="menu" :page="page" documentation-path="manager/products/brand" name="brand">
          <template #content>
            <v-container>
              <div class="tw-mb-4" v-html="$t('products.brand.help')"></div>
              <v-autocomplete
                v-model="brand.id"
                :items="brand.items"
                :label="$t('products.brand.label')"
                item-text="brand_name"
                item-value="id"
                @change="loadBrand"
              />
              <v-btn v-show="!brand.edit" class="primary" small @click="addBrand">
                {{ $t("products.brand.add") }}
              </v-btn>

              <Form v-show="brand.edit" ref="saveBrand" :callback="saveBrand">
                <FormField
                  v-model="brand.brand_name"
                  :props="{ readOnly: !brand.owner }"
                  :read-only="!brand.owner"
                  i18n="products.brand.name"
                  input-type="text"
                  place-holder=" "
                  rules="required"
                />

                <FormField
                  v-model="brand.bsin"
                  :props="{ readOnly: !brand.owner, maxLength: 6 }"
                  :read-only="!brand.owner"
                  i18n="products.brand.bsin"
                  input-type="text"
                  place-holder="9FXVZ7"
                  rules="required"
                  @input="toUpperCase"
                />

                <FormField
                  v-model="brand.website"
                  :props="{ readOnly: !brand.owner }"
                  :read-only="!brand.owner"
                  i18n="products.brand.website"
                  input-type="url"
                  not-required
                  place-holder="https://xyz.com"
                />

                <p v-show="!brand.owner" class="tw-italic" v-html="$t('products.brand.owner')"></p>

                <v-btn v-if="brand.owner" class="mt-4 primary" small @click="$refs.saveBrand.validate()">
                  {{ $t("products.brand.save") }}
                </v-btn>
                <v-btn class="ml-2 mt-4 default" small @click="cancelBrand">
                  {{ $t("products.brand.cancel") }}
                </v-btn>
              </Form>
            </v-container>
          </template>
        </TabPage>
      </template>
    </Tab>
  </div>
</template>

<script>
import tab from "../../../../mixins/tab"
import DragAndDropField from "@/components/common/Form/DragAndDropField"
import { Types as TypesSnackbar } from "@/store/modules/snackbar"

export default {
  name: "Products",
  mixins: [tab],
  components: {
    DragAndDropField,
  },
  data: () => ({
    uploading: false,
    csvDialog: false,
    csvContent: "",
    files: [],
    formatted_files: [],
    current_formatted_file: 0,
    extensions: ["csv", "txt"],
    pages: ["product_list", "product_add", "product_import", "brand"],
    page: "product_list",
    menu: "products",
    brand: {
      items: [],
      item: {},
      id: null,
      edit: false,
      owner: false,
      brand_name: "",
      bsin: "",
      website: "",
    },
    product: {
      items: [],
      item: {},
      id: null,
      edit: false,
      brand_id: null,
      commercial_name: "",
      ean: "",
      internal_code: "",
      image_url: "",
      product_url: "",
      invitation_url: "",
      is_not_visible: true,
      is_not_sharable: false,
      list_order: "last",
      exclude_free: true,
      max_age: "",
    },
    update_product: {
      edit: false,
      id: null,
      brand_id: null,
      commercial_name: "",
      ean: "",
      internal_code: "",
      image_url: "",
      product_url: "",
      invitation_url: "",
      is_not_visible: true,
      is_not_sharable: true,
      exclude_free: true,
      list_order: "last",
      company_id: "xxx",
      commercial_description: "",
      review_description: "",
      max_age: "",
    },
    update_product_edit: false,
    productsLoading: false,
    productsSearch: "",
    productsDatatableHeaders: [],
    productsDatatableItems: [],
    productStatistics: {
      product_id: 0,
      commercial_name: "",
      details: [],
      rating: 0,
      publicationsCount: 0,
    },
    max_ages: [
      { val: "3M", label: "Trois mois d'ancienneté" },
      { val: "6M", label: "Six mois d'ancienneté" },
      { val: "12M", label: "Une année d'ancienneté" },
      { val: "99M", label: "Sans limite d'ancienneté" },
    ],
  }),
  async mounted() {
    this.reloadPreviousOpenedTab()
    await this.fetchBrands()
    this.fetchProducts()
    this.buildProductsDatatableHeaders()
  },
  computed: {
    customerInternalCode() {
      return this.update_product.company_id + ":" + this.update_product.internal_code
    },

  },
  watch: {
    page(newValue) {
      if (newValue === "product_add") {
        this.cancelProduct()
      }
    },
    productStatisticsAvailable() {
      return this.productStatistics.product_id > 0
    },
  },
  methods: {
    rateNow(product) {
      this.productStatistics.product_id = -1
      this.$axios.post("/office/manager/rateproduct", {
        product_id: product.id,
      }).then(response => {

        this.productStatistics.commercial_name = product.commercial_name
        this.productStatistics.product_id = product.id
        this.productStatistics.publicationsCount = response.data.t.c
        this.productStatistics.rating = response.data.t.r
        this.productStatistics.details = response.data

      })
    },
    loadProductForUpdate(product) {
      this.update_product.id = product.id
      this.loadProduct()
    },
    viewProductStatistics(product) {
      this.productStatistics.product_id = -1

      this.$axios.get("office/manager/products/stats/" + product.id).then(response => {

        this.productStatistics.product_id = product.id
        this.productStatistics.commercial_name = product.commercial_name
        this.productStatistics.publicationsCount = response.data.publicationsCount
        this.productStatistics.rating = response.data.rating
        this.productStatistics.details = response.data.details

      })
    },
    highlightSearch(haystack, needle) {
      return haystack.replace(new RegExp(needle, "g"), "<span class='primary lighten-5'>" + needle + "</span>")
    },
    buildProductsDatatableHeaders() {
      this.productsDatatableHeaders = [
        {
          text: "",
          value: "edit",
          sortable: false,
        },
        {
          text: this.$t("products.product.internal_code"),
          align: "start",
          value: "internal_code",
        },
        {
          text: this.$t("products.product.ean"),
          align: "start",
          value: "ean",
        },
        {
          text: this.$t("products.product.commercial_name"),
          align: "start",
          value: "commercial_name",
        },
        {
          text: this.$t("products.brand.name"),
          align: "start",
          value: "name",
        },
        {
          text: this.$t("urls.url.datatable.actions"),
          value: "actions",
          sortable: false,
        },
      ]
    },
    fetchProducts() {
      this.product.items = []
      this.fillProductsDatatableItems()
      this.$axios
        .get("office/manager/products")
        .then(response => {
          this.product.items = response.data
          this.fillProductsDatatableItems()
        })
        .finally(() => {
          this.productsLoading = false
        })
    },
    fillProductsDatatableItems() {
      let items = []

      this.product.items.forEach(item => {
        items.push(this.formatProductsTabledata(item))
      })

      this.productsDatatableItems = items
    },
    formatProductsTabledata(product) {
      //-- Number is used hereafer due to the fact thta is somme case product.brand_id is set to a string like "2" and not like a number 2!
      const brand = this.brand.items.find(item => item.id === Number(product.brand_id))
      return {
        id: product.id,
        product_id: product.id,
        name: brand.brand_name,
        internal_code: product.internal_code,
        ean: product.ean,
        commercial_name: product.commercial_name,
      }
    },
    loadProduct() {

      this.$axios
          .get("office/manager/product/"+this.update_product.id)
          .then(response => {
            this.update_product = response.data
            let product_data = JSON.parse(this.update_product.data);
            this.update_product.is_not_visible = ! (this.update_product.is_visible===1)
            this.update_product.is_not_sharable = ! (this.update_product.is_sharable===1)
            this.update_product.exclude_free = (this.update_product.exclude_free===1)
            this.update_product.image_url = product_data.image_url ;
            this.update_product.product_url = product_data.product_url
            this.update_product.invitation_url = product_data.invitation_url ;
            if(this.update_product.list_order===null) this.update_product.list_order="last"
            this.update_product_edit = true
          })
          .catch(() => {
            this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
              lines: this.$t("products.product.get_error"),
              config: { timeout: 1000 * 6, color: "error" },
            })
          })
    },
    sendProduct() {
      this.uploading = true
      const formData = this.getFormDataFromFiles()

      this.$axios
        .post("office/manager/products/csv", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          this.product.items = response.data
        })
        .catch(() => {
          this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
            lines: this.$t("products.product.upload_error"),
            config: { timeout: 1000 * 6, color: "error" },
          })
        })
        .finally(() => {
          this.uploading = false
        })
    },
    getFormDataFromFiles() {
      let formData = new FormData()
      this.files.forEach((f, x) => {
        formData.append("file_" + (x + 1), f)
      })
      return formData
    },
    addProduct() {
      this.cancelProduct()
    },
    deleteProduct(product) {
      this.$axios.delete("office/manager/products/" + product.id).then(response => {
        if (response.status === 200) {
          this.product.items = this.product.items.filter(item => item.id !== product.id)
          this.fillProductsDatatableItems()
        }
      })
    },
    createProduct() {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("office/manager/products", {
            commercial_name: this.product.commercial_name,
            ean: this.product.ean,
            brand_id: this.product.brand_id,
            internal_code: this.product.internal_code,
            image_url: this.product.image_url,
            product_url: this.product.product_url,
            invitation_url: this.product.invitation_url,
            is_visible: ! this.product.is_not_visible,
            is_sharable: ! this.product.is_not_sharable,
            exclude_free: this.product.exclude_free,
            max_age: this.product.max_age,
            list_order: this.product.list_order,
          })
          .then(response => {
            if (response.status === 200) {
              this.product.items.push(response.data)
              this.cancelProduct()
              this.fillProductsDatatableItems()
            }
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateProduct() {
      return new Promise((resolve, reject) => {
        this.$axios
          .patch("office/manager/products", {
            id: this.update_product.id,
            commercial_name: this.update_product.commercial_name,
            ean: this.update_product.ean,
            brand_id: this.update_product.brand_id,
            internal_code: this.update_product.internal_code,
            image_url: this.update_product.image_url,
            product_url: this.update_product.product_url,
            invitation_url: this.update_product.invitation_url,
            is_visible: ! this.update_product.is_not_visible,
            is_sharable: ! this.update_product.is_not_sharable,
            exclude_free: this.update_product.exclude_free,
            max_age: this.update_product.max_age,
            list_order: this.update_product.list_order,
            commercial_description: this.update_product.commercial_description,
            review_description: this.update_product.review_description,
            product_familly: this.update_product.product_familly,
          })
          .then(() => {
            this.update_product_edit = false
            this.fetchProducts()
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    cancelProduct() {
      this.product.item = {}
      this.product.id = null
      this.product.edit = false
      this.product.brand_id = null
      this.product.commercial_name = ""
      this.product.ean = ""
      this.product.internal_code = ""
      this.product.image_url = ""
      this.product.product_url = ""
      this.product.invitation_url = ""
      this.product.is_not_visible = true
      this.product.is_not_sharable = false
      this.product.exclude_free = true
      this.product.max_age = ""
      this.product.list_order = "last"
    },
    // Fetch all brands
    async fetchBrands() {
      await this.$axios.get("office/manager/brands").then(response => {
        this.brand.items = response.data.data
      })
    },
    // Load brand in fields
    loadBrand() {
      const item = this.brand.items.find(item => item.id === this.brand.id)
      this.brand.item = item === null ? {} : item

      this.brand.owner = item.hasOwnProperty("owner") ? item.owner : false
      this.brand.id = item.hasOwnProperty("id") ? item.id : null
      this.brand.brand_name = item.hasOwnProperty("brand_name") ? item.brand_name : ""
      this.brand.bsin = item.hasOwnProperty("bsin") ? item.bsin : ""
      this.brand.website = item.hasOwnProperty("website") ? item.website : ""
      this.brand.description = item.hasOwnProperty("description") ? item.description : ""
      this.brand.edit = true
    },
    // Add a new brand
    addBrand() {
      this.cancelBrand()
      this.brand.edit = true
      this.brand.owner = true
    },
    // Save the brand
    saveBrand() {
      if (this.brand.owner && this.brand.id === null) {
        return this.createBrand()
      }
      return this.updateBrand()
    },
    // Create the brand
    createBrand() {
      return new Promise((resolve, reject) => {
        this.$axios
          .post("office/manager/brands", {
            brand_name: this.brand.brand_name,
            bsin: this.brand.bsin,
            website: this.brand.website,
            description: this.brand.description,
          })
          .then(response => {
            this.brand.items.push(response.data.data)
            this.cancelBrand()
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // Update the brand
    updateBrand() {
      return new Promise((resolve, reject) => {
        this.$axios
          .patch("office/manager/brands", {
            id: this.brand.id,
            brand_name: this.brand.brand_name,
            bsin: this.brand.bsin,
            website: this.brand.website,
          })
          .then(response => {
            this.brand.items = this.brand.items.filter(brand => brand.id !== this.brand.id)
            this.brand.items.push(response.data.data)
            this.cancelBrand()
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // Back and cancel operations (empty fields)
    cancelBrand() {
      this.brand.item = {}
      this.brand.id = null
      this.brand.edit = false
      this.brand.owner = false
      this.brand.brand_name = ""
      this.brand.bsin = ""
      this.brand.website = ""
      this.brand.description = ""
    },
    // Set the BSIN to uppercase (unable to delete the last wrong character)
    toUpperCase(value) {
      this.brand.bsin = value.toUpperCase()
      const regex = "/[^A-Z0-9]/"
      this.brand.bsin = this.brand.bsin.replace(eval(regex), "")
    },
  },
}
</script>
